var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFDD67","cx":"32","cy":"32","r":"30","key":0}),React.createElement("circle",{"fill":"#664E27","cx":"20.5","cy":"24.592","r":"5","key":1}),React.createElement("circle",{"fill":"#664E27","cx":"43.5","cy":"24.592","r":"5","key":2}),React.createElement("path",{"fill":"#664E27","d":"M48.111 37.02C43.783 43.127 38.66 44.664 32 44.664s-11.783-1.537-16.111-7.645c-.602-.85-2.189-.314-1.839.92C16.323 45.943 24.051 50.605 32 50.605s15.677-4.662 17.95-12.666c.351-1.234-1.237-1.769-1.839-.919z","key":3})]);
}

Icon.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = Icon;

Icon.default = Icon;
